import { Component } from '@angular/core';
import { NavigationType } from '@shared-libs/enums';
import { UserDetailsManager } from '@shared-managers/user-details.manager';
import { IUserDetails } from '@shared-models/user.model';
import { NavigationService } from '@shared-services/navigation.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Component({
	selector: 'home-mobile-page',
	templateUrl: 'home.mobile.page.html',
	styleUrls: ['./home.mobile.page.scss'],
})
export class HomeMobilePage {
	public userDetails: IUserDetails;
	public readonly userDetailsSubject: BehaviorSubject<IUserDetails>;

	constructor(
		private readonly userDetailsManager: UserDetailsManager,
		private navigationService: NavigationService
	) {
		this.userDetailsSubject = this.userDetailsManager.getUserDetails();
		this.userDetailsSubject.subscribe((userDetails) => {
			this.userDetails = userDetails;
		});
	}

	public async goToEvents() {
		await this.navigationService.navigateTo(NavigationType.page, '/internal/activiteiten');
	}
}
